/* eslint-disable no-unused-vars */
import React, { createContext, useReducer } from 'react';
/* eslint-enable no-unused-vars */
// ---
import { BreakPoint } from '../asset/styles';

const mediaBreak = () =>
  window.matchMedia(`(min-width:${BreakPoint.desktop})`).matches;

const events = {
  INITIAL: 'resizingInitial',
  RESIZE: 'resizingResize',
};

const initial = {
  type: events.INITIAL,
  width: -1,
  desktop: mediaBreak(),
};

const reducer = (requestState, action = null) => {
  const state = { ...requestState };
  // console.log('resizing.reducer', state, action)
  // action check - 不正値の時は前回値をかえします
  if (!action || !action.type) {
    return state;
  }

  // type check
  switch (action.type) {
    case events.RESIZE: {
      state.type = action.type;
      state.width = action.width;
      state.desktop = mediaBreak();
      return state;
    }
    // default: {
    //   state.type = events.INITIAL;
    //   state.width = window.innerWidth;
    //   state.desktop = mediaBreak();
    //   return state;
    // }
    // @update - 20191205
    case events.INITIAL: {
      state.type = action.type;
      return state;
    }
    // @update - 20191205
    default: {
      return state;
    }
  }
};

const Context = createContext(initial);

const Provider = props => {
  const [state, dispatch] = useReducer(reducer, initial);
  return (
    <Context.Provider value={{ state, dispatch }}>
      {props.children}
    </Context.Provider>
  );
};

const resizing = {
  events,
  Context,
  Provider,
  initial,
  mediaBreak,
};

export default resizing;



// WEBPACK FOOTER //
// ./src/phase2/survey/context/resizing.js